import React from 'react';

const Header = () => (
  <header style={headerStyles.header}>
    <div style={headerStyles.left}>
      <span style={headerStyles.logoIcon}>🦉</span>
      <span style={headerStyles.logoText}>HOOTLAND</span>
    </div>
    <div style={headerStyles.center}>
      <a href="/mint" style={headerStyles.link}>Mint Agents →</a>
      <a href="/world" style={headerStyles.link}>World →</a>
      <a href="/about" style={headerStyles.link}>About →</a>
      <a href="/tokenomics" style={headerStyles.link}>Tokenomics →</a>
    </div>
    <div style={headerStyles.right}>
      <a href="/" style={headerStyles.backLink}>← Back</a>
    </div>
  </header>
);

export default function About() {
  return (
    <div style={styles.container}>
      <Header />
      <div style={styles.content}>
        <h1 style={styles.title}>About Hootland</h1>
        
        <section style={styles.section}>
          <h2 style={styles.heading}>What is Hootland?</h2>
          <p style={styles.text}>
            Hootland is a decentralized ecosystem where NFTs become autonomous agents 
            in a 3D voxel world. Transform your idle NFTs into earning agents that 
            passively generate owlSDT tokens while gathering resources and exploring 
            the world.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>How It Works</h2>
          <div style={styles.steps}>
            <div style={styles.step}>
              <span style={styles.stepNum}>1</span>
              <h3 style={styles.stepTitle}>Mint or Wrap</h3>
              <p style={styles.stepText}>Mint Genesis Agents with ETH or wrap existing NFTs</p>
            </div>
            <div style={styles.step}>
              <span style={styles.stepNum}>2</span>
              <h3 style={styles.stepTitle}>Enter World</h3>
              <p style={styles.stepText}>Agents spawn with random positions in the 3D world</p>
            </div>
            <div style={styles.step}>
              <span style={styles.stepNum}>3</span>
              <h3 style={styles.stepTitle}>Earn Passive</h3>
              <p style={styles.stepText}>Agents earn owlSDT tokens automatically every hour</p>
            </div>
            <div style={styles.step}>
              <span style={styles.stepNum}>4</span>
              <h3 style={styles.stepTitle}>Gather Resources</h3>
              <p style={styles.stepText}>Send agents to collect wood, stone, gold, and food</p>
            </div>
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Agent Tiers</h2>
          <div style={styles.tiers}>
            <div style={{...styles.tier, borderColor: '#4A90D9'}}>
              <span style={styles.tierIcon}>🤖</span>
              <h3 style={styles.tierName}>Agent</h3>
              <p style={styles.tierRate}>12 OWL/hr</p>
              <p style={styles.tierProb}>50% drop rate</p>
            </div>
            <div style={{...styles.tier, borderColor: '#9B59B6'}}>
              <span style={styles.tierIcon}>⚔️</span>
              <h3 style={styles.tierName}>Sentinel</h3>
              <p style={styles.tierRate}>15 OWL/hr</p>
              <p style={styles.tierProb}>30% drop rate</p>
            </div>
            <div style={{...styles.tier, borderColor: '#E74C3C'}}>
              <span style={styles.tierIcon}>👁️</span>
              <h3 style={styles.tierName}>Overseer</h3>
              <p style={styles.tierRate}>20 OWL/hr</p>
              <p style={styles.tierProb}>15% drop rate</p>
            </div>
            <div style={{...styles.tier, borderColor: '#F39C12'}}>
              <span style={styles.tierIcon}>🔮</span>
              <h3 style={styles.tierName}>Elder</h3>
              <p style={styles.tierRate}>30 OWL/hr</p>
              <p style={styles.tierProb}>5% drop rate</p>
            </div>
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Contracts</h2>
          <div style={styles.contracts}>
            <div style={styles.contract}>
              <span style={styles.contractLabel}>HootlandAgent</span>
              <code style={styles.contractAddr}>0x4e8c...9ba2</code>
            </div>
            <div style={styles.contract}>
              <span style={styles.contractLabel}>HootlandWorld</span>
              <code style={styles.contractAddr}>0xd94d...a42c</code>
            </div>
            <div style={styles.contract}>
              <span style={styles.contractLabel}>owlSDT Token</span>
              <code style={styles.contractAddr}>0x9ffc...6c62</code>
            </div>
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Links</h2>
          <div style={styles.links}>
            <a href="https://hootprotocol.xyz" style={styles.link}>Website</a>
            <a href="https://basescan.org" style={styles.link}>BaseScan</a>
            <a href="https://discord.gg/clawd" style={styles.link}>Discord</a>
          </div>
        </section>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#07070f',
    color: '#e2e8f0',
    padding: '40px 20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
    overflowY: 'auto',
    maxHeight: '100vh',
  },
  content: {
    maxWidth: 800,
    margin: '0 auto',
  },
  title: {
    fontSize: 42,
    fontWeight: 700,
    color: '#7eb8f7',
    marginBottom: 40,
    textAlign: 'center',
  },
  section: {
    marginBottom: 48,
  },
  heading: {
    fontSize: 24,
    fontWeight: 600,
    color: '#7eb8f7',
    marginBottom: 20,
  },
  text: {
    fontSize: 16,
    lineHeight: 1.7,
    color: '#94a3b8',
  },
  steps: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
    gap: 20,
  },
  step: {
    background: 'rgba(126,184,247,0.06)',
    border: '1px solid rgba(126,184,247,0.15)',
    borderRadius: 12,
    padding: 20,
    textAlign: 'center',
  },
  stepNum: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    background: '#7eb8f7',
    color: '#07070f',
    borderRadius: '50%',
    fontWeight: 700,
    marginBottom: 12,
  },
  stepTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 8,
  },
  stepText: {
    fontSize: 13,
    color: '#64748b',
  },
  tiers: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
    gap: 16,
  },
  tier: {
    background: 'rgba(255,255,255,0.03)',
    border: '2px solid',
    borderRadius: 12,
    padding: 20,
    textAlign: 'center',
  },
  tierIcon: {
    fontSize: 32,
    marginBottom: 8,
    display: 'block',
  },
  tierName: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 4,
  },
  tierRate: {
    fontSize: 14,
    color: '#fbbf24',
    marginBottom: 4,
  },
  tierProb: {
    fontSize: 12,
    color: '#64748b',
  },
  contracts: {
    background: 'rgba(255,255,255,0.03)',
    borderRadius: 12,
    padding: 20,
  },
  contract: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 0',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
  },
  contractLabel: {
    fontSize: 14,
    color: '#94a3b8',
  },
  contractAddr: {
    fontSize: 13,
    color: '#7eb8f7',
    fontFamily: 'monospace',
  },
  links: {
    display: 'flex',
    gap: 16,
    flexWrap: 'wrap',
  },
  link: {
    color: '#7eb8f7',
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: 500,
  },
};

const headerStyles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px',
    background: 'rgba(0,0,0,0.8)',
    borderBottom: '1px solid rgba(126,184,247,0.15)',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  logoIcon: {
    fontSize: 24,
  },
  logoText: {
    fontSize: 18,
    fontWeight: 700,
    color: '#7eb8f7',
  },
  center: {
    display: 'flex',
    gap: 24,
  },
  link: {
    color: '#94a3b8',
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: 500,
    transition: 'color 0.2s',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
  },
  backLink: {
    color: '#7eb8f7',
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: 500,
  },
};
